import { API_URL, API_KEY, FILTER_SERVICE } from '../configs/global';

export const FETCH_SEARCH_LOCATION = 'FETCH_SEARCH_LOCATION';

export const fetchSearchLocation = (latitude, longitude) => {
  const url = `${API_URL}/nearest-stop-v1/${latitude}/${longitude}?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;

  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((response) =>
        dispatch({
          type: FETCH_SEARCH_LOCATION,
          payload: response,
        })
      )
      .catch((error) => console.log(error));
  };
};



// WEBPACK FOOTER //
// ./src/actions/SearchLocationAction.js